import React from "react";
import { XIcon } from "staysure-component-library";

import LabelButtonWrapper, {
  IconButtonWrapper,
} from "@/components/atoms/button-wrapper/button-wrapper";
import RichText from "@/components/atoms/rich-text/rich-text";

import Styles from "./corona-modal.module.css";

type CoronaModalProps = {
  title: string;
  description: string;
  confirmCTALabel: string;
  rejectCTALabel: string;
  onSelect?: (e: boolean) => void;
};

function CoronaModal({
  onSelect,
  title,
  description,
  confirmCTALabel,
  rejectCTALabel,
}: Readonly<CoronaModalProps>) {
  return (
    <div className="p-spacing-l md:p-spacing-xxxl">
      <div className="w-spacing-xxxl h-spacing-xxxl absolute m-spacing-xxs right-0 top-0 flex items-center justify-center">
        <IconButtonWrapper
          data-testid="close-corona-modal-button"
          id="close-corona-modal-button"
          hierarchy="tertiary"
          btnType="icon"
          icon={<XIcon stroke="#306582" testId="closeCoronaModalIcon-testid" />}
          className="w-[24px] h-[24px] text-[24px] text-text-on-primary"
          onClick={() => {
            if (onSelect !== undefined) {
              onSelect(false);
            }
          }}
        />
      </div>
      <div>
        <h1
          className="text-text-title mb-spacing-s text-[23px] md:text-[31px]
         font-header-font font-[400] leading-[110%] md:leading-[120%] lg:leading-[110%]"
        >
          {title.replace(/-/g, "\u2011")}
        </h1>
      </div>
      <div className={`${Styles.coronaContent} mb-spacing-l`}>
        <RichText
          className="text-text-body text-[18px] font-body-font font-[400] leading-[150%] "
          richText={description}
        />
      </div>
      <div className="w-full">
        <LabelButtonWrapper
          data-testid="confirm-cta-label-button"
          id="confirm-cta-label-button"
          hierarchy="primary"
          label={confirmCTALabel}
          className="w-full mb-[8px] text-[18px] font-body-font h-[48px] max-h-[48px] font-[600] leading-[100%] text-text-on-primary !rounded-radius-full"
          onClick={() => {
            if (onSelect !== undefined) {
              onSelect(true);
            }
          }}
        />

        <LabelButtonWrapper
          data-testid="reject-cta-label-button"
          id="reject-cta-label-button"
          hierarchy="secondary"
          label={rejectCTALabel}
          className="w-full mr-[8px] text-[18px] font-body-font h-[48px] max-h-[48px] font-[600] leading-[100%] text-text-on-secondary !rounded-radius-full"
          onClick={() => {
            if (onSelect !== undefined) {
              onSelect(false);
            }
          }}
        />
      </div>
    </div>
  );
}

export default CoronaModal;
